import { render, staticRenderFns } from "./leftAside.vue?vue&type=template&id=10cd6cb1&scoped=true&"
import script from "./leftAside.vue?vue&type=script&lang=js&"
export * from "./leftAside.vue?vue&type=script&lang=js&"
import style0 from "./leftAside.vue?vue&type=style&index=0&id=10cd6cb1&scoped=true&lang=less&"
import style1 from "./leftAside.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd6cb1",
  null
  
)

export default component.exports